module.exports = __webpack_public_path__ + "img/图片4.3236c8b1.png";